export const CLASS_NAMES = {
  slider: 'keen-slider',
  slide: 'keen-slider__slide',
};
